// extracted by mini-css-extract-plugin
export default {"formNameBox":"index_formNameBox_p70G2","dot":"index_dot_oaYfC","formName":"index_formName_8Nd62","formWarning":"index_formWarning_L5cDU","formNameStart":"index_formNameStart_Afeas"};